// Helper function to create a proper Date from Google Classroom's UTC time
const createDateFromUTC = (dueDate, dueTime) => {
    // Google Classroom stores dates in UTC
    // Create a UTC date and it will automatically convert to local timezone
    return new Date(Date.UTC(
        dueDate.year,
        dueDate.month - 1,
        dueDate.day,
        dueTime?.hours || 23,
        dueTime?.minutes || 59,
        dueTime?.seconds || 0
    ));
};

export const getTimeRemaining = (dueDate, currentTime) => {
    const due = createDateFromUTC(dueDate, {
        hours: dueDate.hours,
        minutes: dueDate.minutes,
        seconds: dueDate.seconds
    });

    const diff = due - currentTime;

    if (diff < 0) return "Past due";

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (days > 0) return `${days}d ${hours}h remaining`;
    if (hours > 0) return `${hours}h ${minutes}m remaining`;
    return `${minutes}m remaining`;
};

export const formatTime12Hour = (dueTime) => {
    if (!dueTime || dueTime.hours === undefined) return "";

    // Create a date in UTC then display in local time
    const tempDate = new Date(Date.UTC(2000, 0, 1, dueTime.hours, dueTime.minutes || 0));

    const hours12 = tempDate.getHours() % 12 || 12;
    const ampm = tempDate.getHours() >= 12 ? 'PM' : 'AM';
    const minutes = tempDate.getMinutes().toString().padStart(2, '0');

    return ` at ${hours12}:${minutes} ${ampm}`;
};

export const recentClass = (course) => {
    const updateDate = new Date(course.updateTime);
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    return updateDate > oneYearAgo;
};